export default (api) => ({
    getInfo: () => api.get('/environments/info'),
})
